import type { RiskCode } from './types';

/**
 * Figma-specific colors that don't map cleanly to the MUI palette.
 * Brand-adaptive colors (blue text, pink accents) are pulled from the theme
 * (`primary.main` / `secondary.main`) at the call site instead.
 */
export const WEATHER_MODAL_COLORS = {
    /** Application-suitability pill backgrounds/text. */
    pill: {
        apto: { bg: '#D3FFD7', text: '#053709' },
        aptoAdjust: { bg: '#F2F2B6', text: '#404006' },
        noApto: { bg: '#FFC18D', text: '#652D01' },
    },
    /** Risk dot colors used in the tooltip breakdown (matches the app's G/Y/R convention). */
    riskDot: { G: '#3BB827', Y: '#F6B40E', R: '#FF0000' },
    /** Frost-risk footer banner. */
    frost: { bg: '#FFE4CD', text: '#974401' },
    /** Current-conditions panel background. */
    surfaceVariant: '#F5F5F5',
} as const;

export const getRiskDotColor = (code: RiskCode): string => {
    const dots = WEATHER_MODAL_COLORS.riskDot;
    return dots[code as keyof typeof dots] ?? dots.R;
};
